var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
// Export Specific Theme tokens
import { DEFAULT_THEME } from './presets/default';
import { get, camelCase } from 'lodash';
import * as polished from 'polished';
import { css } from 'styled-components';
import { map, omit, first, compact } from 'lodash';
import * as themes from './presets';
import { toArray } from '@shapeable/utils';
export * from './presets';
export * from './types';
export var minWidth = {
  base: 320,
  phone: 400,
  landscape: 500,
  tablet: 768,
  desktop: 1024,
  maxContent: 1435,
  maxContentPad: 1465,
  desktopMid: 1280,
  desktopLarge: 1440,
  desktopFullHD: 1920,
  desktop4Column: 1940,
  desktop5Column: 2260,
  desktop6Column: 2500,
  baseDevice: 320,
  phoneDevice: 400,
  landscapeDevice: 500,
  tabletDevice: 768,
  desktopDevice: 1024,
  maxContentDevice: 1435,
  maxContentPadDevice: 1465,
  desktopMidDevice: 1280,
  desktopLargeDevice: 1440,
  desktopFullHDDevice: 1920,
  desktop4ColumnDevice: 1940,
  desktop5ColumnDevice: 2260,
  desktop6ColumnDevice: 2500
};
export var to = Object.keys(minWidth).reduce(function (acc, label) {
  acc[label] = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (max-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media (max-width: ", "px) {\n      ", "\n    }\n  "])), minWidth[label] - 1, css.apply(null, args || []));
  };
  return acc;
  // tslint:disable-next-line
}, {});
export var from = Object.keys(minWidth).reduce(function (acc, label) {
  // this now includes a check on reserved width
  // if there is reserved width, breakpoints then must cut in at a higher point
  // whis is equal to their regular width + the reserved width
  acc[label] = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", " \n  "], ["\n    ", " \n  "])), function (_a) {
      var theme = _a.theme;
      return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "], ["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "])), minWidth[label] + (label.includes('Device') ? 0 : theme.reservedWidth || 0), css.apply(null, args || []));
    });
  };
  return acc;
  // tslint:disable-next-line
}, {});
export var EXTRA_CSS = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), function (_a) {
  var _b = _a.extraStyles,
    extraStyles = _b === void 0 ? '' : _b;
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), extraStyles);
});
export var breakpoints = function (styles) {
  var without = omit(styles, ['base', 'last', 'extra']);
  var others = map(without, function (props, key) {
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), from[key](templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), props));
  });
  return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), styles.base, others, styles.last, styles.extra);
};
export var JustifyToAlign = {
  start: 'left',
  end: 'right',
  center: 'center'
};
var normalizeKey = function (key) {
  return compact(key.split('.')).map(function (key) {
    return camelCase(key);
  }).join('.');
};
// gets a token which is NOT mode-dependent. e.g. fonts, grid unit, etc
export var getToken = function (props, key, useFallback) {
  if (useFallback === void 0) {
    useFallback = true;
  }
  var themeKeyPath = normalizeKey(key);
  return get(props, "theme.".concat(themeKeyPath), useFallback ? get(DEFAULT_THEME, themeKeyPath) : undefined);
};
// gets a token which is mode-dependent, e.g. colors, opacity for dark mode
export var getModeToken = function (props, key, useFallback) {
  if (useFallback === void 0) {
    useFallback = true;
  }
  var activeMode = get(props, 'theme.activeMode', 'light');
  var themeKeyPath = "".concat(activeMode, ".").concat(normalizeKey(key));
  var lightThemeKeyPath = "light.".concat(normalizeKey(key));
  return get(props, "theme.".concat(themeKeyPath), get(props, "theme.".concat(lightThemeKeyPath), useFallback ? get(DEFAULT_THEME, themeKeyPath) : undefined));
};
export var getTokenFromKeys = function (_a) {
  var props = _a.props,
    parentPath = _a.parentPath,
    _b = _a.getter,
    getter = _b === void 0 ? getToken : _b,
    keys = _a.keys,
    fallbackValue = _a.fallbackValue;
  var validKeys = compact(keys);
  var keyToUse = validKeys.find(function (key) {
    return !!getter(props, "".concat(parentPath).concat(camelCase(key)), false);
  });
  // if nohing matched a token, we need to assume that this is just a value the dev wants
  // e.g. HEX values, or CSS colors 
  if (!keyToUse) {
    return first(validKeys) || fallbackValue;
  }
  return getter(props, "".concat(parentPath, ".").concat(camelCase(keyToUse)), false) || keyToUse;
};
export var grid = function (props, value, plus) {
  return "".concat(value * getToken(props, 'grid.unit') + (plus || 0), "px");
};
// TODO - remove this, it's a bit unclear and is a legacy platform thing
export var gridSize = function (props, type, size, breakpoint, cssUnit) {
  if (cssUnit === void 0) {
    cssUnit = 'px';
  }
  var multiplier = getToken(props, "grid.".concat(type, ".").concat(size, ".").concat(breakpoint), false) || 4;
  var unit = getToken(props, 'grid.unit');
  return "".concat(multiplier * unit).concat(cssUnit);
};
/*
Color functions attempt to find a color at the specified key in the theme object from props,
(provided by a styled components ThemeProvider). If this is not found, we assume we have just been
given a standard CSS color string.
*/
export var color = function (props) {
  var keys = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    keys[_i - 1] = arguments[_i];
  }
  return getTokenFromKeys({
    props: props,
    keys: keys,
    getter: getModeToken,
    parentPath: 'color.',
    fallbackValue: '#000000'
  });
};
export var modeColorToken = function (props, key) {
  var activeMode = get(props, 'theme.activeMode', 'light');
  var colors = props.colors || {};
  var modeColors = get(colors, 'dark', {});
  var modeKey = activeMode === 'dark' ? modeColors[key] || colors[key] : colors[key];
  return modeKey;
};
export var fill = function (props) {
  var keys = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    keys[_i - 1] = arguments[_i];
  }
  return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    path, rect, circle, polygon {\n      ", "\n      fill: ", ";\n    }\n  "], ["\n    path, rect, circle, polygon {\n      ", "\n      fill: ", ";\n    }\n  "])), theme.TRANSITION('fill')(props), color.apply(void 0, __spreadArray([props], keys, false)));
};
export var opacity = function (props, key) {
  return getModeToken(props, "theme.opacity.".concat(camelCase(key)), false) || 1;
};
;
export var maxLines = function (props, lines) {
  return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "], ["\n    display: -webkit-box;\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "])), lines);
};
export var dotBG = function (props, direction, colors, size, distance) {
  if (direction === void 0) {
    direction = 'h';
  }
  if (colors === void 0) {
    colors = 'line';
  }
  if (size === void 0) {
    size = 2;
  }
  if (distance === void 0) {
    distance = 6;
  }
  var radius = size / 2;
  var colorValue = color.apply(void 0, __spreadArray([props], toArray(colors), false));
  var fill = colorValue.replace('#', '%23');
  var viewBoxBound = direction === 'v' ? "".concat(size, " ").concat(distance) : "".concat(distance, " ").concat(size);
  var backgroundRepeat = direction === 'both' ? 'repeat' : direction === 'v' ? 'repeat-y' : 'repeat-x';
  var backgroundSize = direction === 'v' ? "".concat(size, "px ").concat(distance, "px") : "".concat(distance, "px ").concat(size, "px");
  return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' viewbox='0 0 ", "'><circle r='", "' cx='", "' cy='", "' fill='", "'></circle></svg>\");\n    background-repeat: ", ";\n    background-size: ", ";\n  "], ["\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' viewbox='0 0 ", "'><circle r='", "' cx='", "' cy='", "' fill='", "'></circle></svg>\");\n    background-repeat: ", ";\n    background-size: ", ";\n  "])), viewBoxBound, radius, radius, radius, fill, backgroundRepeat, backgroundSize);
};
export var prop = function (props, key, unit) {
  if (unit === void 0) {
    unit = '';
  }
  return "".concat(getToken(props, key, false) || '').concat(unit);
};
export var fontFamily = function (props, key) {
  return getToken(props, "font.family.".concat(key), false) || key;
};
/* Wrappers for `polished` manipulations, for more concise consumers */
export var lighten = function (props, key, by) {
  if (by === void 0) {
    by = 0.1;
  }
  var colorValue = color.apply(void 0, __spreadArray([props], toArray(key), false));
  if (colorValue) {
    try {
      var lightened = polished.lighten(by, colorValue);
      return lightened;
    } catch (e) {
      return colorValue;
    }
  }
  return '#000000';
};
export var darken = function (props, key, by) {
  if (by === void 0) {
    by = 0.1;
  }
  var colorValue = color.apply(void 0, __spreadArray([props], toArray(key), false));
  if (colorValue) {
    try {
      var darkened = polished.darken(by, colorValue);
      return darkened;
    } catch (e) {
      return colorValue;
    }
  }
  return '#000000';
};
export var rem = function (props, size) {
  return "".concat(size / (getToken(props, "fonts.size.base", false) || 16), "rem");
};
/* ---- Ready made prop function creators, which allow for simpler declarations ---- */
/**
 * Generates an SVG background of a line of dots (or grid of dots, if direction is both)
 *
 * @param direction The direction of the line, or use 'both' to create a grid
 * @param colorKey The symbolc color name (taken from the theme)
 * @param size The width/height of each dot
 * @param distance The distance between the centers of each dot
 */
export var DOT_BG = function (direction, colorKey, size, distance) {
  if (direction === void 0) {
    direction = 'h';
  }
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }
  if (size === void 0) {
    size = 2;
  }
  if (distance === void 0) {
    distance = 4;
  }
  return function (props) {
    return dotBG(props, direction, colorKey, size, distance);
  };
};
export var H_DOT_BG = function (colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }
  if (size === void 0) {
    size = 2;
  }
  if (distance === void 0) {
    distance = 4;
  }
  return function (props) {
    return dotBG(props, 'h', colorKey, size, distance);
  };
};
export var V_DOT_BG = function (colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }
  if (size === void 0) {
    size = 2;
  }
  if (distance === void 0) {
    distance = 4;
  }
  return function (props) {
    return dotBG(props, 'v', colorKey, size, distance);
  };
};
export var H_DOT_BG_END = function (colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }
  if (size === void 0) {
    size = 2;
  }
  if (distance === void 0) {
    distance = 4;
  }
  return function (props) {
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", ";\n  background-position: bottom left;\n"], ["\n  ", ";\n  background-position: bottom left;\n"])), dotBG(props, 'h', colorKey, size, distance));
  };
};
export var V_DOT_BG_END = function (colorKey, size, distance) {
  if (colorKey === void 0) {
    colorKey = 'lineMid';
  }
  if (size === void 0) {
    size = 2;
  }
  if (distance === void 0) {
    distance = 4;
  }
  return function (props) {
    return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", ";\n  background-position: top right;\n"], ["\n  ", ";\n  background-position: top right;\n"])), dotBG(props, 'v', colorKey, size, distance));
  };
};
export var HOVER_SHADOW = function () {
  return function (props) {
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  box-shadow: 0 0 8px -3px ", ";\n"], ["\n  box-shadow: 0 0 8px -3px ", ";\n"])), COLOR('subtle-shadow')(props));
  };
};
/**
 * Creates a prop function to provide a font-family for a given symbolic name (specified in the theme)
 * @param key the symbolic variant name for the font family. e.g. 'heading', 'sans', etc
 */
export var FONT = function (key) {
  return function (props) {
    return fontFamily(props, key);
  };
};
/**
 * Creates a prop function to compute the correct rem value for a given size
 * @param size The final intended point size
 */
export var FONT_SIZE = function (size) {
  return function (props) {
    return rem(props, size);
  };
};
/**
 * Creates a prop function to compute rem value for a named breakpoint (taken from the theme)
 * @param breakpoint the name of the breakpoint to use
 * @param variant the size variant for breakpoint size (allows multiple sets of responsive sizes)
 */
export var FONT_SIZE_FOR = function (breakpoint, variant) {
  if (variant === void 0) {
    variant = 'normal';
  }
  return function (props) {
    return rem(props, parseInt(prop(props, "font.size.".concat(camelCase(variant), ".").concat(camelCase(breakpoint))), 10));
  };
};
/**
 * Creates a prop function to provide an em line height for a given symbolic font variant (specified in the theme)
 * @param key the symbolic variant name for the font family. e.g. 'heading', 'sans', etc
 */
export var LINE_HEIGHT = function (key) {
  return function (props) {
    return prop(props, "lineHeight.".concat(key), 'em');
  };
};
/**
 * Creates a prop function to provide a color for a given symbolic name (specified in the `color` section of theme)
 * @param key the symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 */
export var COLOR = function () {
  var keys = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    keys[_i] = arguments[_i];
  }
  return function (props) {
    return color.apply(void 0, __spreadArray([props], keys, false));
  };
};
/**
 * Creates a prop function to provide a darkened ciolor for a given symbolic name (specified in the `color` section of theme)
 * @param key the symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 */
export var DARKEN = function (key, by) {
  return function (props) {
    return darken(props, key, by);
  };
};
/**
 * Creates a prop function to provide a lightened hover color for a given symbolic color key (specified in the `color` section of theme)
 * @param key The symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 * @param lightenBy The decimal percentage to lighten by (as used by the `polished` package)
 */
export var HOVER_COLOR = function (key, lightenBy) {
  if (lightenBy === void 0) {
    lightenBy = 0.2;
  }
  return function (props) {
    return lighten(props, key, lightenBy);
  };
};
/**
 * Creates a prop function to provide an svg fill for a given symbolic name (specified in the `color` section of theme)
 * where an "SVG-fill" means to color fill any paths, polygons, shapes descending from the element applied to.
 * @param key the symbolic variant name for the color. e.g. 'primary', 'secondary', 'yellow' etc
 */
export var FILL = function () {
  var keys = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    keys[_i] = arguments[_i];
  }
  return function (props) {
    return fill.apply(void 0, __spreadArray([props], keys, false));
  };
};
// apply transition duration to given css properties. e.g. theme.TRANSITION('color', 'background-color');
export var TRANSITION = function () {
  var cssProps = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    cssProps[_i] = arguments[_i];
  }
  return function (props) {
    return css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  transition-property: ", ";\n  transition-duration: ", ";\n"], ["\n  transition-property: ", ";\n  transition-duration: ", ";\n"])), cssProps.join(', '), DURATION()(props));
  };
};
/**
 * Creates a prop function to provide a background color for a given symbolic name (specified in the `background` section of theme)
 * @param key the symbolic variant name for the background color. e.g. 'primary', 'secondary', 'yellow' etc
 */
export var MIN = function (key, unit) {
  if (unit === void 0) {
    unit = 'px';
  }
  return function (props) {
    return prop(props, "dimension.min.".concat(camelCase(key)), unit);
  };
};
export var MAX = function (key, unit) {
  if (unit === void 0) {
    unit = 'px';
  }
  return function (props) {
    return prop(props, "dimension.max.".concat(camelCase(key)), unit);
  };
};
export var DURATION = function () {
  return function (props) {
    return "".concat(getToken(props, 'duration', false) || 0.3, "s");
  };
};
export var MAX_LINES = function (lines) {
  return function (props) {
    return maxLines(props, lines);
  };
};
export var UNIT = function (multiple, plus) {
  return function (props) {
    return grid(props, multiple, plus || 0);
  };
};
export var GRID_SIZE = function (type, size, breakpoint, cssUnit) {
  if (cssUnit === void 0) {
    cssUnit = 'px';
  }
  return function (props) {
    return gridSize(props, type, size, breakpoint, cssUnit);
  };
};
export var CENTER_WITHIN = function (width, unit) {
  if (unit === void 0) {
    unit = 'px';
  }
  return css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  width: 100%;\n  max-width: ", "", ";\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  max-width: ", "", ";\n  margin: 0 auto;\n"])), width, unit);
};
/**
 * Generates a full set of media query rules which vary font sizes based on the breakpoint
 *
 * @param variant The size variant, which allows multiple sets of sizes to be applied to the breakpoints.
 */
export var RESPONSIVE_FONT_SIZE = function (variant) {
  if (variant === void 0) {
    variant = 'normal';
  }
  return function (props) {
    return breakpoints({
      base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('base', variant)),
      landscape: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('landscape', variant)),
      tablet: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('tablet', variant)),
      desktop: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('desktop', variant)),
      desktopLarge: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), FONT_SIZE_FOR('desktop-large', variant))
    });
  };
};
export var CENTER = function (direction) {
  if (direction === void 0) {
    direction = 'both';
  }
  return function (props) {
    return css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n"])), (direction === 'both' || direction === 'v') && css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    justify-content: center;\n  "], ["\n    justify-content: center;\n  "]))), (direction === 'both' || direction === 'h') && css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    align-items: center;\n  "], ["\n    align-items: center;\n  "]))));
  };
};
export var REMOVE_BUTTON_STYLE = function (variant) {
  if (variant === void 0) {
    variant = 'normal';
  }
  return function (props) {
    return css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  padding: 0;\n  outline: none;\n  margin: 0;\n"], ["\n  background: none;\n  border: none;\n  padding: 0;\n  outline: none;\n  margin: 0;\n"])));
  };
};
export var OPACITY = function (key) {
  return function (props) {
    return opacity(props, key);
  };
};
export var TEXT_ALIGN = function (justify) {
  return function (props) {
    return JustifyToAlign[justify];
  };
};
export var strokeFillColors = function (props, _a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
  var isActive = _a.isActive,
    isDisabled = _a.isDisabled,
    _2 = _a.autoTransition,
    autoTransition = _2 === void 0 ? true : _2,
    colors = _a.colors,
    _3 = _a.selector,
    selector = _3 === void 0 ? '' : _3;
  var mode = (_b = props === null || props === void 0 ? void 0 : props.theme) === null || _b === void 0 ? void 0 : _b.activeMode;
  var modeColors = get(colors, mode, colors) || {};
  var SELECTOR_START = selector ? "".concat(selector, " {") : '';
  var SELECTOR_END = selector ? '}' : '';
  return css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n    ", "\n     \n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    \n  "], ["\n    ", "\n\n    ", "\n\n    ", "\n     \n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    \n  "])), autoTransition && css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      ", "\n      transition-property: stroke, fill;\n      transition-duration: ", ";\n      ", "\n    "], ["\n      ", "\n      transition-property: stroke, fill;\n      transition-duration: ", ";\n      ", "\n    "])), SELECTOR_START, DURATION()(props), SELECTOR_END), (modeColors === null || modeColors === void 0 ? void 0 : modeColors.stroke) && css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n      ", "\n      stroke: ", ";\n      ", "\n    "], ["\n      ", "\n      stroke: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.stroke), SELECTOR_END), (modeColors === null || modeColors === void 0 ? void 0 : modeColors.fill) && css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n      ", "\n      fill: ", ";\n      ", ";\n      ", "\n    "], ["\n      ", "\n      fill: ", ";\n      ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.fill), fill(props, modeColors.fill), SELECTOR_END), isActive && ((_c = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _c === void 0 ? void 0 : _c.stroke) && css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n      ", "\n      stroke: ", ";\n      ", "\n    "], ["\n      ", "\n      stroke: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.active.stroke), SELECTOR_END), isActive && ((_d = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _d === void 0 ? void 0 : _d.fill) && css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n      ", "\n      fill: ", ";\n      ", ";\n      ", "\n    "], ["\n      ", "\n      fill: ", ";\n      ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.active.fill), fill(props, modeColors.active.fill), SELECTOR_END), ((_e = modeColors === null || modeColors === void 0 ? void 0 : modeColors.hover) === null || _e === void 0 ? void 0 : _e.stroke) && css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        stroke: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        stroke: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, modeColors.hover.stroke), SELECTOR_END), ((_f = modeColors === null || modeColors === void 0 ? void 0 : modeColors.hover) === null || _f === void 0 ? void 0 : _f.fill) && css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        fill: ", ";\n        ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        fill: ", ";\n        ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, modeColors.hover.fill), fill(props, modeColors.hover.fill), SELECTOR_END), isActive && (((_h = (_g = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _g === void 0 ? void 0 : _g.hover) === null || _h === void 0 ? void 0 : _h.stroke) || ((_j = modeColors.active) === null || _j === void 0 ? void 0 : _j.stroke)) && css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        stroke: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        stroke: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_l = (_k = modeColors.active) === null || _k === void 0 ? void 0 : _k.hover) === null || _l === void 0 ? void 0 : _l.stroke, (_m = modeColors.active) === null || _m === void 0 ? void 0 : _m.stroke), SELECTOR_END), isActive && (((_p = (_o = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _o === void 0 ? void 0 : _o.hover) === null || _p === void 0 ? void 0 : _p.fill) || ((_q = modeColors.active) === null || _q === void 0 ? void 0 : _q.fill)) && css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        fill: ", ";\n        ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        fill: ", ";\n        ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_s = (_r = modeColors.active) === null || _r === void 0 ? void 0 : _r.hover) === null || _s === void 0 ? void 0 : _s.fill, ((_t = modeColors.active) === null || _t === void 0 ? void 0 : _t.fill) || ''), fill(props, ((_v = (_u = modeColors.active) === null || _u === void 0 ? void 0 : _u.hover) === null || _v === void 0 ? void 0 : _v.fill) || ((_w = modeColors.active) === null || _w === void 0 ? void 0 : _w.fill) || ''), SELECTOR_END), isDisabled && (((_x = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _x === void 0 ? void 0 : _x.stroke) || modeColors.stroke) && css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        stroke: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        stroke: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_y = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _y === void 0 ? void 0 : _y.stroke, modeColors.stroke || ''), SELECTOR_END), isDisabled && (((_z = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _z === void 0 ? void 0 : _z.fill) || modeColors.fill) && css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        fill: ", ";\n        ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        fill: ", ";\n        ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_0 = modeColors.disabled) === null || _0 === void 0 ? void 0 : _0.fill, modeColors.fill || ''), fill(props, ((_1 = modeColors.disabled) === null || _1 === void 0 ? void 0 : _1.fill) || modeColors.fill || ''), SELECTOR_END));
};
export var textBackgroundBorderColors = function (props, _a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
  var isActive = _a.isActive,
    isDisabled = _a.isDisabled,
    _16 = _a.autoTransition,
    autoTransition = _16 === void 0 ? true : _16,
    colors = _a.colors,
    _17 = _a.selector,
    selector = _17 === void 0 ? '' : _17;
  var mode = (_b = props === null || props === void 0 ? void 0 : props.theme) === null || _b === void 0 ? void 0 : _b.activeMode;
  var modeColors = get(colors, mode, colors) || {};
  var SELECTOR_START = selector ? "".concat(selector, " {") : '';
  var SELECTOR_END = selector ? '}' : '';
  return css(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n    \n    ", "\n\n    \n\n\n    ", "\n\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n    \n    ", "\n\n    \n\n\n    ", "\n\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), autoTransition && css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n      ", "\n      transition-property: color, background-color, border-color, outline-color;\n      transition-duration: ", ";\n      ", "\n    "], ["\n      ", "\n      transition-property: color, background-color, border-color, outline-color;\n      transition-duration: ", ";\n      ", "\n    "])), SELECTOR_START, DURATION()(props), SELECTOR_END), (modeColors === null || modeColors === void 0 ? void 0 : modeColors.text) && css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n      ", "\n      color: ", ";\n      ", "\n    "], ["\n      ", "\n      color: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.text), SELECTOR_END), ((_c = modeColors === null || modeColors === void 0 ? void 0 : modeColors.hover) === null || _c === void 0 ? void 0 : _c.text) && css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        color: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, modeColors.hover.text), SELECTOR_END), isActive && ((_d = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _d === void 0 ? void 0 : _d.text) && css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n      ", "\n      color: ", ";\n      ", "\n    "], ["\n      ", "\n      color: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.active.text), SELECTOR_END), isActive && (((_f = (_e = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _e === void 0 ? void 0 : _e.hover) === null || _f === void 0 ? void 0 : _f.text) || ((_g = modeColors.active) === null || _g === void 0 ? void 0 : _g.text)) && css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        color: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_j = (_h = modeColors.active) === null || _h === void 0 ? void 0 : _h.hover) === null || _j === void 0 ? void 0 : _j.text, (_k = modeColors.active) === null || _k === void 0 ? void 0 : _k.text), SELECTOR_END), (modeColors === null || modeColors === void 0 ? void 0 : modeColors.background) && css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n      ", "\n      background: ", ";\n      ", "\n    "], ["\n      ", "\n      background: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.background), SELECTOR_END), isActive && ((_l = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _l === void 0 ? void 0 : _l.background) && css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n      ", "\n      background: ", ";\n      ", "\n    "], ["\n      ", "\n      background: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.active.background), SELECTOR_END), ((_m = modeColors === null || modeColors === void 0 ? void 0 : modeColors.hover) === null || _m === void 0 ? void 0 : _m.background) && css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        background: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        background: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, modeColors.hover.background), SELECTOR_END), isActive && (((_p = (_o = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _o === void 0 ? void 0 : _o.hover) === null || _p === void 0 ? void 0 : _p.background) || ((_q = modeColors.active) === null || _q === void 0 ? void 0 : _q.background)) && css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        background: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        background: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_s = (_r = modeColors.active) === null || _r === void 0 ? void 0 : _r.hover) === null || _s === void 0 ? void 0 : _s.background, ((_t = modeColors.active) === null || _t === void 0 ? void 0 : _t.background) || ''), SELECTOR_END), (modeColors === null || modeColors === void 0 ? void 0 : modeColors.border) && css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n      ", "\n      border-color: ", ";\n      ", "\n    "], ["\n      ", "\n      border-color: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.border), SELECTOR_END), ((_u = modeColors === null || modeColors === void 0 ? void 0 : modeColors.hover) === null || _u === void 0 ? void 0 : _u.border) && css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        border-color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        border-color: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, modeColors.hover.border), SELECTOR_END), isActive && ((_v = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _v === void 0 ? void 0 : _v.border) && css(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n      ", "\n      border-color: ", ";\n      ", "\n    "], ["\n      ", "\n      border-color: ", ";\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.active.border), SELECTOR_END), isActive && (((_x = (_w = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _w === void 0 ? void 0 : _w.hover) === null || _x === void 0 ? void 0 : _x.border) || ((_y = modeColors.active) === null || _y === void 0 ? void 0 : _y.border)) && css(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        border-color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        border-color: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_0 = (_z = modeColors.active) === null || _z === void 0 ? void 0 : _z.hover) === null || _0 === void 0 ? void 0 : _0.border, ((_1 = modeColors.active) === null || _1 === void 0 ? void 0 : _1.border) || ''), SELECTOR_END), (modeColors === null || modeColors === void 0 ? void 0 : modeColors.bold) && css(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n      ", "\n      b, strong { \n        color: ", "; \n      }\n      ", "\n    "], ["\n      ", "\n      b, strong { \n        color: ", "; \n      }\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.bold), SELECTOR_END), ((_2 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.hover) === null || _2 === void 0 ? void 0 : _2.bold) && css(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        b, strong { \n          color: ", "; \n        }\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        b, strong { \n          color: ", "; \n        }\n        ", "\n      }\n    "])), SELECTOR_START, color(props, modeColors.hover.bold), SELECTOR_END), isActive && ((_3 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _3 === void 0 ? void 0 : _3.bold) && css(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n      ", "\n      b, strong { \n        color: ", "; \n      }\n      ", "\n    "], ["\n      ", "\n      b, strong { \n        color: ", "; \n      }\n      ", "\n    "])), SELECTOR_START, color(props, modeColors.active.bold), SELECTOR_END), isActive && (((_5 = (_4 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.active) === null || _4 === void 0 ? void 0 : _4.hover) === null || _5 === void 0 ? void 0 : _5.bold) || ((_6 = modeColors.active) === null || _6 === void 0 ? void 0 : _6.bold)) && css(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        b, strong { \n          color: ", ";\n        }\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        b, strong { \n          color: ", ";\n        }\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_8 = (_7 = modeColors.active) === null || _7 === void 0 ? void 0 : _7.hover) === null || _8 === void 0 ? void 0 : _8.bold, ((_9 = modeColors.active) === null || _9 === void 0 ? void 0 : _9.bold) || ''), SELECTOR_END), isDisabled && (((_10 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _10 === void 0 ? void 0 : _10.text) || modeColors.text) && css(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        color: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_11 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _11 === void 0 ? void 0 : _11.text, modeColors.text || ''), SELECTOR_END), isDisabled && (((_12 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _12 === void 0 ? void 0 : _12.border) || modeColors.border) && css(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        border-color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        border-color: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_13 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _13 === void 0 ? void 0 : _13.border, modeColors.border || ''), SELECTOR_END), isDisabled && (((_14 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _14 === void 0 ? void 0 : _14.background) || modeColors.background) && css(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n      &:hover {\n        ", "\n        background: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n        background: ", ";\n        ", "\n      }\n    "])), SELECTOR_START, color(props, (_15 = modeColors === null || modeColors === void 0 ? void 0 : modeColors.disabled) === null || _15 === void 0 ? void 0 : _15.background, modeColors.background || ''), SELECTOR_END));
};
export var allColors = function (props, args) {
  return css(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", "\n  "], ["\n    ", ";\n    ", ";\n    ", "\n  "])), textBackgroundBorderColors(props, __assign(__assign({}, args), {
    autoTransition: false
  })), args.ignorePaths ? '' : strokeFillColors(props, __assign(__assign({}, args), {
    autoTransition: false
  })), args.autoTransition && css(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n      ", "\n      transition-property: stroke, fill, color, background-color, border-color, outline-color;\n      transition-duration: ", ";\n      ", "\n    "], ["\n      ", "\n      transition-property: stroke, fill, color, background-color, border-color, outline-color;\n      transition-duration: ", ";\n      ", "\n    "])), args.selector ? "".concat(args.selector, " {") : '', DURATION()(props), args.selector ? "}" : ''));
};
export var STROKE_FILL_COLORS = function (args) {
  return function (props) {
    return strokeFillColors(props, args);
  };
};
export var TEXT_BACKGROUND_BORDER_COLORS = function (args) {
  return function (props) {
    return textBackgroundBorderColors(props, args);
  };
};
export var APPLY_COLORS = function (args) {
  return function (props) {
    return allColors(props, __assign(__assign({}, args), {
      autoTransition: args.autoTransition === undefined ? true : args.autoTransition
    }));
  };
};
export var APPLY_NON_PATH_COLORS = function (args) {
  return function (props) {
    return allColors(props, __assign(__assign({}, args), {
      autoTransition: args.autoTransition === undefined ? true : args.autoTransition,
      ignorePaths: true
    }));
  };
};
export var ALL_COLORS = APPLY_COLORS;
export var applyFonts = function (props, args) {
  var _a, _b;
  return css(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n  "])), ((_a = args.fontTypes) === null || _a === void 0 ? void 0 : _a.body) && css(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n      ", "\n      font-family: ", ";\n      p, ul, li, ol {\n        font-family: ", ";\n      }\n    "], ["\n      ", "\n      font-family: ", ";\n      p, ul, li, ol {\n        font-family: ", ";\n      }\n    "])), args.selector ? "".concat(args.selector, " {") : '', fontFamily(props, args.fontTypes.body), fontFamily(props, args.fontTypes.body)), ((_b = args.fontTypes) === null || _b === void 0 ? void 0 : _b.header) && css(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n      h1, h2, h3, h4, h5, h6 {\n        font-family: ", ";\n      }\n    "], ["\n      h1, h2, h3, h4, h5, h6 {\n        font-family: ", ";\n      }\n    "])), fontFamily(props, args.fontTypes.header)), args.selector ? "}" : '');
};
export var APPLY_FONTS = function (args) {
  return function (props) {
    return applyFonts(props, args);
  };
};
export var theme = {
  EXTRA_CSS: EXTRA_CSS,
  DOT_BG: DOT_BG,
  H_DOT_BG: H_DOT_BG,
  V_DOT_BG: V_DOT_BG,
  H_DOT_BG_END: H_DOT_BG_END,
  V_DOT_BG_END: V_DOT_BG_END,
  FONT: FONT,
  DURATION: DURATION,
  TRANSITION: TRANSITION,
  OPACITY: OPACITY,
  FONT_SIZE: FONT_SIZE,
  FONT_SIZE_FOR: FONT_SIZE_FOR,
  LINE_HEIGHT: LINE_HEIGHT,
  COLOR: COLOR,
  DARKEN: DARKEN,
  HOVER_COLOR: HOVER_COLOR,
  HOVER_SHADOW: HOVER_SHADOW,
  FILL: FILL,
  MAX_LINES: MAX_LINES,
  MIN: MIN,
  MAX: MAX,
  UNIT: UNIT,
  GRID_SIZE: GRID_SIZE,
  CENTER_WITHIN: CENTER_WITHIN,
  RESPONSIVE_FONT_SIZE: RESPONSIVE_FONT_SIZE,
  CENTER: CENTER,
  REMOVE_BUTTON_STYLE: REMOVE_BUTTON_STYLE,
  TEXT_ALIGN: TEXT_ALIGN,
  STROKE_FILL_COLORS: STROKE_FILL_COLORS,
  TEXT_BACKGROUND_BORDER_COLORS: TEXT_BACKGROUND_BORDER_COLORS,
  ALL_COLORS: ALL_COLORS,
  APPLY_COLORS: APPLY_COLORS,
  APPLY_NON_PATH_COLORS: APPLY_NON_PATH_COLORS,
  APPLY_FONTS: APPLY_FONTS
};
export { themes, DEFAULT_THEME };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63;